module.exports = __webpack_public_path__ + "img/sale_and_installation_of_tires.0a5d8bd6.svg";